import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-surlCarrier-lookup',
  templateUrl: './micro-surlCarrier-lookup.component.html'
})
export class MicroSurlCarrierLookupComponent  {

  @Input()
  surlCarrierId:any;
}
